import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!

  return (_openBlock(), _createElementBlock("button", {
    class: "favorite-button",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createVNode(_component_FeatherIcon, {
      icon: "heart",
      size: "16",
      class: _normalizeClass(_ctx.iconClass)
    }, null, 8, ["class"]),
    _createTextVNode(),
    _createElementVNode("span", {
      class: _normalizeClass(["text-size-14", _ctx.textColor])
    }, _toDisplayString(_ctx.text), 3)
  ]))
}